import { render, staticRenderFns } from "./TableBase.vue?vue&type=template&id=4bf9de40&scoped=true&"
import script from "./TableBase.vue?vue&type=script&lang=js&"
export * from "./TableBase.vue?vue&type=script&lang=js&"
import style0 from "./TableBase.vue?vue&type=style&index=0&id=4bf9de40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9de40",
  null
  
)

export default component.exports